// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QJQE","label":"styles_label__EjsBl"};